import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarSimpleRightSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSidebarSimpleRightSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V21H21V3ZM5 5H15V19H5V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleRightSquare;
